export default __webpack_public_path__ + "static/lozenge-dropdown-do-1-dark-f6995b645dffe41371a6946da89c1ec323cc9fb29dc9f35a472491a442a84679.png";